import Vue from 'vue'

import Cookies from 'js-cookie'

import Web3 from 'web3'
if (typeof window.ethereum !== 'undefined') {
  window.web3 = new Web3(window.ethereum)
}

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './assets/styles/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/en'
import VueClipboard from 'vue-clipboard2'

import '@/assets/styles/index.scss' // global css
import '@/assets/styles/ruoyi.scss' // ruoyi css
import App from './App'
import store from './store'
import router from './router'
import permission from './directive/permission'

import './assets/icons' // icon
import './permission' // permission control
import { getDicts } from '@/api/system/dict/data'
import { getAbi } from '@/api/file'
import { getConfigKey } from '@/api/system/config'
import { parseTime, resetForm, addDateRange, selectDictLabel, download } from '@/utils/ruoyi'
import Pagination from '@/components/Pagination'
import PageTitle from '@/components/PageTitle'
import PageCard from '@/components/PageCard'
import PageBottom from '@/components/PageBottom'
import FileUpload from '@/components/FileUpload'
import LoadingBtn from '@/components/LoadingBtn'
import dict from '@/utils/dict.js'
import BigNumber from '@/components/BigNumber'
import Account from '@/components/Account'
import SearchSelect from '@/components/SearchSelect'
import SearchDate from '@/components/SearchDate'
import { CheckAccount } from '@/layout/components/metaMaskInit/accountHandler.js'

import * as filters from '@/utils/filters.js'
// Global filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import '@/utils/lib-flexible/flexible.js'
if (process.env.VUE_APP_ISMOCK === '1') { // Judge whether it is mock mode
  require('./mock/index.js')
}

import _BigNumber from 'bignumber.js'
Vue.prototype.BigNumber = _BigNumber

// 全局方法挂载
Vue.prototype.getAbi = getAbi
Vue.prototype.getDicts = getDicts
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.download = download
Vue.prototype.dict = dict
Vue.prototype.CheckAccount = CheckAccount

Vue.prototype.moment = require('moment')

Vue.prototype.msgSuccess = function(msg) {
  this.$message({ showClose: true, message: msg, type: 'success' })
}
Vue.prototype.msgError = function(msg) {
  this.$message({ showClose: true, message: msg, type: 'error' })
}

Vue.prototype.msgInfo = function(msg) {
  this.$message.info(msg)
}

// Global component mount
Vue.component('Pagination', Pagination)
Vue.component('PageTitle', PageTitle)
Vue.component('PageCard', PageCard)
Vue.component('PageBottom', PageBottom)
Vue.component('FileUpload', FileUpload)
Vue.component('LoadingBtn', LoadingBtn)
Vue.component('BigNumber', BigNumber)
Vue.component('Account', Account)
Vue.component('SearchSelect', SearchSelect)
Vue.component('SearchDate', SearchDate)
Vue.use(VueClipboard)
Vue.use(permission)

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */

Vue.use(Element, {
  locale,
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
